<div class="page-section">

    <p class="page-heading">Schedule a Meeting</p>

    <!-- <p class="page-description-heading">Support Team Hours of Operation</p> -->
    
    <div class="calendar-filter-section">
  <div class="btn-group">
    <div
      class="btn btn-primary"
      mwlCalendarPreviousView
      [view]="view"
      [(viewDate)]="viewDate"
      (viewDateChange)="closeOpenMonthViewDay()"
    >
      Previous
    </div>
    <div
      class="btn btn-outline-secondary"
      mwlCalendarToday
      [(viewDate)]="viewDate"
    >
      Today
    </div>
    <div
      class="btn btn-primary"
      mwlCalendarNextView
      [view]="view"
      [(viewDate)]="viewDate"
      (viewDateChange)="closeOpenMonthViewDay()"
    >
      Next
    </div>
  </div>
  <p class="date-heading">
    {{ viewDate | calendarDate: view + "ViewTitle" : "en" }}
  </p>
  <div class="btn-group">
    <!-- <div
      class="btn btn-primary"
      (click)="setView(CalendarView.Month)"
      [class.active]="view === CalendarView.Month"
    >
      Month
    </div> -->
    <div
      class="btn btn-primary"
      (click)="setView(CalendarView.Week)"
      [class.active]="view === CalendarView.Week"
    >
      Week
    </div>
    <div
      class="btn btn-primary"
      (click)="setView(CalendarView.Day)"
      [class.active]="view === CalendarView.Day"
    >
      Day
    </div>
  </div>
</div>

<!-- <div class="row text-center">
	<div class="col-md-4">
		<div class="btn-group">
			<div class="btn btn-primary" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()">Previous</div>
			<div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate">Today</div>
			<div class="btn btn-primary" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay()">Next</div>
		</div>
	</div>
	<div class="col-md-6">
		<h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
	</div>
	<div class="col-md-4">
		<div class="btn-group">
			<div class="btn btn-primary" (click)="setView(CalendarView.Month)" [class.active]="view === CalendarView.Month">Month</div>
			<div class="btn btn-primary" (click)="setView(CalendarView.Week)" [class.active]="view === CalendarView.Week">Week</div>
			<div class="btn btn-primary" (click)="setView(CalendarView.Day)" [class.active]="view === CalendarView.Day">Day</div>
		</div>
	</div>
</div> -->

<br />
<ng-container *ngIf="page_loaded">
  <div [ngSwitch]="view">
    <mwl-calendar-month-view
      *ngSwitchCase="CalendarView.Month"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="eventClicked($event.day)"
      (eventClicked)="openSpecificEventModal($event.event, $event.day)"
      (dayClicked)="onDayClick($event.day.date)"
    >
    </mwl-calendar-month-view>
    <!-- <mwl-calendar-month-view
      *ngSwitchCase="CalendarView.Month"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      [cellTemplate]="customCellTemplate"
      [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="dayClicked($event.day)"
      (eventClicked)="handleEvent('Clicked', $event.event)"
    >
    </mwl-calendar-month-view> -->
    <!-- <mwl-calendar-week-view
      *ngSwitchCase="CalendarView.Week"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      (dayClicked)="eventClicked($event.day)"
      (eventClicked)="handleEvent('Clicked', $event.event)"
      (eventTimesChanged)="eventTimesChanged($event)"
    >
    </mwl-calendar-week-view> -->

    <mwl-calendar-week-view
      *ngSwitchCase="CalendarView.Week"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      (eventClicked)="openSpecificEventModal($event.event, $event.day)"
      (hourSegmentClicked)="onHourSegmentClick($event.date)"
    >
    </mwl-calendar-week-view>

    <mwl-calendar-day-view
      *ngSwitchCase="CalendarView.Day"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      (eventClicked)="openSpecificEventModal($event.event, $event.day)"
      (hourSegmentClicked)="onHourSegmentClick($event.date)"
    >
    </mwl-calendar-day-view>
  </div>
</ng-container>
<ng-container *ngIf="!page_loaded">
  <app-loader [loading_text]="'Loading Meetings'"></app-loader>
</ng-container>

<ng-template #dayEventsModal>
  <div class="page-modal-section">
    <div class="page-modal-heading-section">
      <span
        >Meetings for
        {{ selected_events_data.date | date: "dd MMM YYYY" }}</span
      >
      <span class="page-modal-close-icon" (click)="closeDayEventModal()"
        >&times;</span
      >
    </div>
    <div class="page-modal-content-section">
      <div class="events-overflow-section">
        <table class="events-table">
          <thead>
            <tr>
              <th>Topic</th>
              <th>Start Date</th>
              <th>End Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let activity of selected_events_data.events">
              <td [matTooltip]="activity.title">{{ activity.title }}</td>
              <td>{{ activity.start | date: "dd-MMM-yyyy  h:mm a" }}</td>
              <!-- <td >{{activity.end | date: 'dd-MMM-yyyy  h:mm a'}}</td> -->
              <td>{{ activity.end_date | date: "dd-MMM-yyyy  h:mm a" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="page-modal-footer-section">
      <button class="page-modal-primary-button" (click)="closeDayEventModal()">
        Close
      </button>
    </div>
  </div>
</ng-template>

<ng-template #specificEventsModal>
  <div class="page-modal-section">
    <!-- <div class="page-modal-heading-section">
      <span>{{ specific_event_data.title }}</span>
      <span class="page-modal-close-icon" (click)="closeSpecificEventModal()"
        >&times;</span
      >
    </div> -->
    <div class="page-modal-content-section">
      <div class="events-overflow-section">
        <table class="events-table">
          <thead>
            <tr>
              <th>Topic</th>
              <th>Start Date</th>
              <th>End Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td [matTooltip]="specific_event_data.title">
                {{ specific_event_data.title }}
              </td>
              <td>
                {{ specific_event_data.start | date: "dd-MMM-yyyy  h:mm a" }}
              </td>
              <td>
                {{ specific_event_data.end_date | date: "dd-MMM-yyyy  h:mm a" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="page-modal-footer-section">
      <button
        class="page-modal-primary-button"
        (click)="closeSpecificEventModal()"
      >
        Close
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modalContent123 let-close="close">
  <div class="modal-header">
    <h2 class="modal-title">{{ modalData?.event.title }}</h2>
    <button type="button" class="close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- <div>
		Event:
		<pre>{{ modalData?.event | json }}</pre>
		</div> -->
    <!-- <div class="py-5">
		<p>Greetings <strong>{{user_details.first_name}} {{user_details.last_name}}!!,</strong></p>
		<p>You have a scheduled event - <strong>{{modalData?.event.title}}</strong></p>
		</div> -->
    <div class="event-details-section">
      <p class="event-owner-name">
        {{ user_details.first_name }} {{ user_details.last_name }}
      </p>
      <p>{{ modalData?.event.start | date: "EEEE, MMMM d, y, h:mm:ss a" }}</p>
    </div>
  </div>
  <!-- <div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="close()">
		OK
		</button>
	</div> -->
</ng-template>

<ng-template #modalContent let-close="close">
  <div class="event-modal-section">
    <p class="event-date">
      {{ modalData.event[0].start | date: "dd MMM YYYY" }}
    </p>
    <div class="events-overflow-section">
      <div
        class="each-event-section"
        *ngFor="let event_data of modalData.event; let index = index"
      >
        <span>{{ index + 1 }}. {{ event_data.title }}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #createEventModal>
  <div class="page-modal-section" style="width: 400px;">
    <div class="page-modal-heading-section">
      <span>Schedule a Meeting</span>
      <span class="page-modal-close-icon" (click)="closeCreateEventModal()">&times;</span>
    </div>
    <div class="page-modal-content-section">
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Date *</p>
        <P class="page-modal-input">{{create_meeting_data.start_date | date: "dd-MMM-yyyy  h:mm a" }}</P>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Topic *</p>
        <input type="text" class="page-modal-input" [(ngModel)]="create_meeting_data.topic" />
        <p class="page-modal-input-error" *ngIf="create_meeting_data_errors.topic">Topic is Required.</p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Duration *</p>
        <mat-select class="page-modal-input" [(ngModel)]="create_meeting_data.duration">
            <mat-option [value]="''">Select Duration</mat-option>
            <mat-option *ngFor="let duration_slot of duration_slots" [value]="duration_slot.value">{{duration_slot.name}}</mat-option>
        </mat-select>
        <p class="page-modal-input-error" *ngIf="create_meeting_data_errors.duration">Duration is Required.</p>
      </div>
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Timezone *</p>
        <mat-select class="page-modal-input" [(ngModel)]="create_meeting_data.timezone">
            <mat-option [value]="''">Select Timezone</mat-option>
            <mat-option *ngFor="let timezone of timezone_list" [value]="timezone.value">{{timezone.name}}</mat-option>
        </mat-select>
        <p class="page-modal-input-error" *ngIf="create_meeting_data_errors.timezone">Timezone is Required.</p>
      </div>
    </div>
    <div class="page-modal-footer-section">
      <button
        class="page-modal-primary-button"
        (click)="createEventData()"
        *ngIf="!event_loader"
      >
        Save
      </button>
      <button
        class="page-modal-primary-button"
        *ngIf="event_loader"
      >
        Saving...
      </button>
      <button
        class="page-modal-secondary-button"
        (click)="closeCreateEventModal()"
      >
        Cancel
      </button>
    </div>
  </div>
</ng-template>


</div>
